import { createStyles, makeStyles } from "@material-ui/core";
import cls from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";

export type LayoutCellProps = {
    rows?: number;
    columns?: number;
    children: React.ReactNode;
    className?: string;
};

const useLayoutCellStyles = makeStyles<RelodeTheme, LayoutCellProps>(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                gridRowEnd: props =>
                    props.rows > 1 ? `span ${props.rows}` : "unset",
                gridColumnEnd: props =>
                    props.columns > 1 ? `span ${props.columns}` : "unset",
            },
        }),
    { name: "LayoutCell" }
);

export const LayoutCell = (props: LayoutCellProps) => {
    const classes = useLayoutCellStyles(props);

    return (
        <div className={cls(classes.root, props.className)}>
            {props.children}
        </div>
    );
};
